// logger.client.ts

import consola from 'consola';
import type { RouteLocationNormalizedLoaded, Router } from 'vue-router';
import { defineNuxtPlugin, useRuntimeConfig } from '#app';

function getInferredContextName(
  route: RouteLocationNormalizedLoaded | undefined
): string {
  return route?.matched?.[0]?.components?.default?.name || 'UnknownContext';
}

function getContextName(nuxtApp: any, context?: string): string {
  if (!import.meta.client) return 'UnknownContext';
  const router = nuxtApp.$router as Router;
  const route = router.currentRoute.value as
    | RouteLocationNormalizedLoaded
    | undefined;
  return context || getInferredContextName(route);
}

export default defineNuxtPlugin((nuxtApp) => {
  const runtimeConfig = useRuntimeConfig();

  function log(message: string, context?: string, ...args: any[]): void {
    const contextName = getContextName(nuxtApp, context);
    if (runtimeConfig.public.isDev) {
      consola.log(`[${contextName}] ${message}`, ...args);
    }
  }

  function logError(error: Error, context?: string, ...args: any[]): void {
    const contextName = getContextName(nuxtApp, context);
    if (runtimeConfig.public.isDev) {
      consola.error(`[${contextName}]`, error, ...args);
    }
  }

  function logInfo(message: string, context?: string, ...args: any[]): void {
    const contextName = getContextName(nuxtApp, context);
    if (runtimeConfig.public.isDev) {
      consola.info(`[${contextName}] ${message}`, ...args);
    }
  }

  function logWarning(message: string, context?: string, ...args: any[]): void {
    const contextName = getContextName(nuxtApp, context);
    if (runtimeConfig.public.isDev) {
      consola.warn(`[${contextName}] ${message}`, ...args);
    }
  }

  function logBox(message: string, context?: string, ...args: any[]): void {
    const contextName = getContextName(nuxtApp, context);
    if (runtimeConfig.public.isDev) {
      consola.box(`[${contextName}] ${message}`, ...args);
    }
  }

  nuxtApp.provide('log', log);
  nuxtApp.provide('logError', logError);
  nuxtApp.provide('logInfo', logInfo);
  nuxtApp.provide('logWarning', logWarning);
  nuxtApp.provide('logBox', logBox);
});
